import { C, DOLOR_ROWS, NIVELES, ZONES, zoneForScore } from "./constants";

const Chip = ({ r }) => (
  <span className="inline-block rounded-md bg-white px-2 py-1 text-[12px] font-semibold border" style={{ color: C.text, borderColor: "rgba(14,31,25,0.15)" }} data-testid={`tablero-matrix-chip-${r.area}`}>
    {r.area} · {r.nombre}
  </span>
);

const Cell = ({ zone, items }) => {
  const z = ZONES[zone];
  return (
    <div className="rounded-lg p-2.5 min-h-[96px] flex flex-col gap-1.5" style={{ background: z.bg }}>
      <span className="text-[10px] font-bold uppercase tracking-[0.14em]" style={{ color: z.fg }}>{zone}</span>
      <div className="flex flex-wrap gap-1.5">{items.map((r) => <Chip key={r.area} r={r} />)}</div>
    </div>
  );
};

const Grid = ({ result }) => (
  <div className="hidden md:grid gap-2" style={{ gridTemplateColumns: "110px repeat(4, minmax(0, 1fr))" }} data-testid="tablero-matrix-grid">
    <div />
    {NIVELES.map((n) => (
      <div key={n.nivel} className="text-[12px] font-bold text-center pb-1" style={{ color: C.text }}>{n.label}</div>
    ))}
    {DOLOR_ROWS.map((row) => [
      <div key={`l-${row.band}`} className="text-[12px] font-bold flex items-center" style={{ color: C.text }}>{row.label}</div>,
      ...NIVELES.map((n) => (
        <Cell
          key={`${row.band}-${n.nivel}`}
          zone={zoneForScore(row.idx + (4 - n.nivel))}
          items={result.filter((r) => r.dolor_band === row.band && r.nivel === n.nivel)}
        />
      )),
    ])}
    <div />
    <div className="col-span-4 text-center text-[11px] pt-1" style={{ color: "#5B6B64" }}>Madurez según tu informe</div>
  </div>
);

const MobileList = ({ result }) => (
  <div className="md:hidden space-y-2" data-testid="tablero-matrix-list">
    {result.map((r) => {
      const z = ZONES[r.zona];
      return (
        <div key={r.area} className="rounded-lg p-3" style={{ background: z.bg }}>
          <div className="text-[10px] font-bold uppercase tracking-[0.14em]" style={{ color: z.fg }}>{r.zona}</div>
          <div className="text-sm font-semibold mt-0.5" style={{ color: C.text }}>{r.area} · {r.nombre}</div>
          <div className="text-[12px] mt-0.5" style={{ color: z.fg }}>Madurez: {r.nivel_label} · Dolor {r.dolor_band}</div>
        </div>
      );
    })}
  </div>
);

export const Capa3Matrix = ({ result }) => (
  <div>
    <Grid result={result} />
    <MobileList result={result} />
  </div>
);
